"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timeToRead = {
    /**
     * Initialises the functionality.
     * Checks if the element has a data-target attribute and if so, calculates the time to read the content and updates the element's text content.
     * https://w3collective.com/calculate-reading-time-javascript/
     *
     * @param {HTMLElement} el - The element to initialise the functionality on.
     * @returns {void}
     *
     * @example
     *
     * <span class="js-time-to-read" data-target="content" data-loc="%time% min read"></span>
     */
    init: function (el) {
        const text = el.dataset.target ? document.getElementById(el.dataset.target)?.innerText : null;
        if (text) {
            const wpm = 225;
            const words = text.trim().split(/\s+/).length;
            const time = Math.ceil(words / wpm);
            const loc = el.dataset.loc ? el.dataset.loc : '';
            el.innerText = loc.replace('%time%', time.toString());
        }
    },
};
exports.default = timeToRead;
